import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';
import { AttributeDefinitionCondition } from '../attributes/attributeDefinitionCondition';
import { AttributeDefinitionSubFieldItem } from '../attributes/attributeDefinitionSubFieldItem';

export class FormAttributeDefinition extends AttributeDefinition {
  public showCurrentValue: boolean;
  public isSubField: boolean;
  constructor(
    id: string,
    entityType: string,
    uiType: string,
    name: string,
    description: string,
    adminDocumentation: string,
    filterable: boolean,
    featured: boolean,
    showOnCreate: boolean,
    isSubField: boolean,
    required: boolean,
    min: string,
    max: string,
    allowsUserAddedValues: boolean,
    valueList: AttributeDefinitionValueListItem[],
    subFieldList: AttributeDefinitionSubFieldItem[],
    showCurrentValue: boolean,
    isReadOnly: boolean,
    isHidden: boolean,
    conditions: AttributeDefinitionCondition[],
    formPageId: string
  ) {
    super(
      id,
      entityType,
      uiType,
      name,
      null, // Passing null for slug because FormAttributeDefinition does not use slugs, unlike other AttributeDefinition usages.
      description,
      adminDocumentation,
      filterable,
      featured,
      required,
      isReadOnly,
      isHidden,
      false,
      showOnCreate,
      isSubField,
      min,
      max,
      allowsUserAddedValues,
      valueList,
      subFieldList,
      null,
      null,
      null,
      null,
      null
    );
    this.showCurrentValue = showCurrentValue;
    this.conditions = conditions;
    this.formPageId = formPageId;
  }

  static parse(obj: Partial<FormAttributeDefinition>): FormAttributeDefinition {
    return new FormAttributeDefinition(
      obj.id,
      obj.entityType,
      obj.uiType,
      obj.name,
      obj.description,
      obj.adminDocumentation,
      obj.filterable,
      obj.featured,
      obj.showOnCreate,
      obj.isSubField,
      obj.required,
      obj.min,
      obj.max,
      obj.allowsUserAddedValues,
      obj.valueList,
      obj.subFieldList,
      obj.showCurrentValue,
      obj.isReadOnly,
      obj.isHidden,
      obj.conditions,
      obj.formPageId
    );
  }
}
